import {
  NumberFormats,
  predefinedNumberFormats,
  type NumberFormat,
} from '@databases/types/database';

import { type FieldConfiguration } from './types';

const CURRENCY_SYMBOLS: Record<string, string> = {
  us_dollar: '$',
  euro: '€',
  pound: '£',
  yen: '¥',
  australian_dollar: 'A$',
};

export function parseNumberFormat(
  formatValue: string
): Partial<FieldConfiguration> | undefined {
  const trimmedValue = formatValue.trim();

  let numberFormat: NumberFormat | undefined;

  if (trimmedValue === 'number') {
    numberFormat = predefinedNumberFormats[NumberFormats.NUMBER];
  } else if (trimmedValue === 'percent') {
    numberFormat = predefinedNumberFormats[NumberFormats.PERCENT];
  } else if (trimmedValue.startsWith('currency_')) {
    const currencyType = trimmedValue.substring('currency_'.length);
    const currencySymbol = CURRENCY_SYMBOLS[currencyType];

    if (currencySymbol) {
      numberFormat = {
        ...predefinedNumberFormats[NumberFormats.CURRENCY],
        format: NumberFormats.CURRENCY,
        prefix: currencySymbol,
      };
    }
  }

  return numberFormat ? { numberFormat } : undefined;
}
